import mutations from './mutations';
import { IMAGE_UPLOAD_STATE } from '../../../constants';

const state = {
  images: []
};

const getters = {
  getImageFromFile: (stateData) => (file) =>
    stateData.images.find((image) => image.file.dataURL === file.dataURL),

  getImageFromImageData: (stateData) => (dataSrc) =>
    stateData.images.find((image) => image.file.dataURL === dataSrc),

  getAddedImages: (stateData) => () =>
    stateData.images.filter((image) => image.state === IMAGE_UPLOAD_STATE.STATE_ADDED),

  getUploadedImages: (stateData) => () =>
    stateData.images.filter(
      (image) =>
        image.state === IMAGE_UPLOAD_STATE.STATE_UPLOADED ||
        image.state === IMAGE_UPLOAD_STATE.STATE_UPLOADED_AGAIN
    ),

  hasUploadContentInDropzone: (stateData) => () =>
    stateData.images.findIndex(
      (image) =>
        image.state === IMAGE_UPLOAD_STATE.STATE_UPLOADED ||
        image.state === IMAGE_UPLOAD_STATE.STATE_UPLOADED_AGAIN
    ) !== -1
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
